import React from 'react'
import Navbar from '../Components/Common/Navbar/Navbar'
import BannerSection from '../Components/Common/BannerSection/BannerSection'
import BannerData from '../Helpers/BannerData'
import Profile from '../Components/AboutPage/Profile/Profile';
import Mission from '../Components/AboutPage/Mission/Mission';
import Footer from '../Components/Common/Footer/Footer';
import Founder from '../Components/AboutPage/Founder/Founder';
import { Helmet } from 'react-helmet';

function About() {
    const { AboutH2, AboutImg } = BannerData;
    return (
        <div className='About'>
            <Helmet>
                <title>About - DocsPro | Healthcare Marketing</title>
                <meta name="description"
                    content="Discover our journey revolutionizing healthcare marketing at DocsPro. Committed to empowering practices to thrive online, attract patients, and grow."></meta>
            </Helmet>
            <Navbar />
            <BannerSection h2={AboutH2} imgUrl={AboutImg} />
            <Profile />
            <Founder />
            <Mission />
            <Footer />


        </div>
    )
}

export default About